import { render, staticRenderFns } from "./siOrderConfirm.vue?vue&type=template&id=bc820e7e&scoped=true&"
import script from "./siOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./siOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./siOrderConfirm.vue?vue&type=style&index=0&id=bc820e7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc820e7e",
  null
  
)

component.options.__file = "siOrderConfirm.vue"
export default component.exports